import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, ComponentPublicInstance } from "vue";
import { useApi } from "@/plugins/api/api";
import { useAlert } from "@/plugins/alert/alert";
import { Messages } from "@/message";
import SubmitButton from "@/components/button/SubmitButton.vue";
import UserInfoForm, { UserInfo } from "./UserInfoForm.vue";

type Props = {
  userId?: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoEdit',
  props: {
    userId: null
  },
  setup(__props: any) {

const props = __props as {
  userId?: number;
};

const { $get, $put, Paths } = useApi();
const { $alert } = useAlert();



const form = ref<UserInfo>();

const vform = ref<ComponentPublicInstance<typeof UserInfoForm>>();

const onSearch = async () => {
  const result = await $get<UserInfo>(
    `${Paths.userMaster.info.default}/${props.userId}`
  );
  if (result) form.value = result;
};

const update = async () => {
  const result = await $put(
    `${Paths.userMaster.info.default}/${props.userId}`,
    form.value
  );
  if (result) {
    $alert("success", Messages.Success.Update);
    await onSearch();
  } else {
    $alert("error", Messages.Fail.Update);
  }
};

const onSubmit = async () => {
  if (!vform.value?.validate()) {
    $alert("warning", Messages.Form.Validate);
    return;
  }
  await update();
};

onMounted(async () => {
  await onSearch();
});

return { __sfc: true,$get, $put, Paths, $alert, props, form, vform, onSearch, update, onSubmit, SubmitButton, UserInfoForm }
}

})